export default __webpack_public_path__ + "static/media/groundnut.cc5d8cfe.png";